import { render, staticRenderFns } from "./ODTMadres.vue?vue&type=template&id=1944e587&scoped=true&"
import script from "./ODTMadres.vue?vue&type=script&lang=js&"
export * from "./ODTMadres.vue?vue&type=script&lang=js&"
import style0 from "./ODTMadres.vue?vue&type=style&index=0&id=1944e587&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1944e587",
  null
  
)

export default component.exports